import React, {useEffect, useState} from 'react';
import OnboardPassword from "../base/onboard-password/OnboardPassword";
import OnboardButton from "../base/onboard-button-component/OnboardButton";
import NotNullCheck from "../../util/NotNullCheck";
import EndUseAgreementTTNETCheckbox from "../../component/custom/EndUseAgreementTTNETCheckbox";
import {isEmpty, rnd} from "../../util/Validation";
import LoginStateManager from "../../util/LoginStateManager";
import VerifyTypeEnum from "../../enum/VerifyTypeEnum";
import {checkEmail} from "../../model/UserRegisterModel";
import OnboardTabsInner from "../base/onboard-tabs-inner-component/OnboardTabsInner";
import OnboardInput from "../base/onboard-input/OnboardInput";
import {setSimulationNumber} from '../../util/SimulationManager';

const MilesAndSmilesLoginComponent = (props) => {
    const {t, i18n, navigate, user} = props.props;
    const simulationNumber = setSimulationNumber();
    const isSimulation = setSimulationNumber();

    const [error, setError] = useState(null);
    const [memberId, setMemberId] = useState(user.memberId);
    const [email, setEmail] = useState(null);
    const [selectOption, setSelectOption] = useState(1);
    const [passcode, setPasscode] = useState(null);
    const [approve, setApprove] = useState(null);
    const [milesProcessing, setMilesProcessing] = useState(false);

    const {
        processLoginMilesAndSmiles1,
        processLoginMilesAndSmiles2,
        processLoginMilesAndSmiles3,
        processLoginMilesAndSmiles4
    } = new LoginStateManager(props.props, VerifyTypeEnum.MILES_A_SMILES);

    const validation = () => {
        if (selectOption === 1) {
            if (NotNullCheck(controlMemberId())) {
                processLoginMilesAndSmiles1(memberId.replace(" | ", "").replace("|", "").replaceAll(" ", ""), passcode);
            }
        } else if (selectOption === 2) {
            if (NotNullCheck(controlEmail())) {
                processLoginMilesAndSmiles3(email, passcode);
            }
        }
    }

    const controlMemberId = () => {
        let valid = {
            input: (memberId == null || memberId.length === 0) ? t('error.empty_member_id') : null,
            passcode: (passcode == null || passcode.length === 0) ? rnd(t('error.empty_password')) :
                (passcode.length < 4 ? rnd(t('error.empty_password_four')) : null),
            approve: (approve == null || !approve) ? t('error.empty_approve') : null
        };
        setError(valid);
        return valid;
    }

    const controlEmail = () => {
        let valid = {
            input: (email == null || !email) ? rnd(t('error.empty_email')) : (!checkEmail(email) ? rnd(t('error.empty_mail_payment_format')) : null),
            passcode: (passcode == null || passcode.length === 0) ? rnd(t('error.empty_password')) :
                (passcode.length < 4 ? rnd(t('error.empty_password_four')) : null),
            approve: (approve == null || !approve) ? t('error.empty_approve') : null
        };
        setError(valid);
        return valid;
    }

    useEffect(() => {
        if (error !== null) {
            if (selectOption === 1) controlMemberId();
            else if (selectOption === 2) controlEmail();
        }
    }, [i18n.language])

    const isNavigateRouteLoginOffer = () => {
        return props.state === 'loginOffer';
    }

    const handleSelectOption = (e) => {
        setSelectOption(e);
        setError(null);
        if (e === 2) {
            if (isSimulation) {
                simulationNumber(10, 3);
                setEmail("deneme@test.com");
                setPasscode("111111");
                setApprove(true);
            }
        }
    }

    useEffect(() => {
        if (isSimulation) {
            setMemberId("TK123456789");
            setPasscode("111111");
            setApprove(true);
        }
    }, []);

    return (
        <div>

            <OnboardTabsInner
                defaultActiveTab={1}
                onChange={(e) => handleSelectOption(e)}
                tabs={[
                    {label: t('login.input_member_id'), value: 1},
                    {label: t('login.input_ms_email'), value: 2}]}
            />

            {selectOption === 1 && (
                <OnboardInput placeholder={t('login.input_ms_member_id')}
                              onChange={(e) => setMemberId(e)}
                              error={error?.input}
                              validation={isEmpty(memberId, t('error.empty_member_id'))}
                              mask={{mask: "TK \\| 9{1,9}", definitions: {"*": {casing: "upper"}}}}
                              value={memberId}/>
            )}

            {selectOption === 2 && (
                <OnboardInput placeholder={t('login.input_ms_email')}
                              onChange={(e) => setEmail(e)} type="email"
                              error={error?.input}
                              value={email}/>
            )}

            <div className="h-8"/>

            <OnboardPassword placeholder={t('login.password')} onChange={(e) => setPasscode(e)}
                             error={error?.passcode} showForgotPassword
                             validation={isEmpty(passcode, t('error.empty_password'))}
                             onClickPasswordForgot={() => navigate("/forgot-password", {state: isNavigateRouteLoginOffer() ? "offer" : "login"})}
                             value={passcode}/>

            <div className="h-20"/>

            <EndUseAgreementTTNETCheckbox
                showMilesApprove
                milesApproveOnChange={(val) => setMilesProcessing(val)}
                value={approve}
                error={error?.approve}
                onChange={(e) => setApprove(e)}
            />

            <div className="h-16"/>

            <OnboardButton label={t('login.login_btn')} onClick={() => validation()}/>

        </div>
    );
};

export default MilesAndSmilesLoginComponent;

